import React from "react";
import { useApp } from "@/context/AppContext";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { Globe, Check } from "lucide-react";

export const LanguageSwitcher = () => {
  const { lang, setLang } = useApp();
  const options = [
    { key: "de", label: "DE \u2014 Deutsch" },
    { key: "en", label: "EN \u2014 English" },
  ];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-2" data-testid="language-switcher">
          <Globe className="h-4 w-4" />
          <span className="uppercase font-medium">{lang}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {options.map((o) => (
          <DropdownMenuItem
            key={o.key}
            onClick={() => setLang(o.key)}
            data-testid={`language-option-${o.key}`}
            className="gap-2"
          >
            <span className="w-4">{lang === o.key && <Check className="h-4 w-4" />}</span>
            {o.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
